import { render, staticRenderFns } from "./ConfirmRatingIcon.vue?vue&type=template&id=9844953c"
import script from "./ConfirmRatingIcon.vue?vue&type=script&lang=js"
export * from "./ConfirmRatingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports